import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';

import Start from './pages/Start.vue';
import Board from './pages/Board.vue';
import End from './pages/End.vue';

Vue.config.productionTip = false;

Vue.use(VueRouter);

const routes = [
  { path: '/', component: Start },
  { path: '/board', component: Board },
  { path: '/einde', component: End }
];

export const router = new VueRouter({
  mode: 'history',
  routes
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
